<template>
  <modal  v-model="visible" width="700px" @on-ok="addStageReport" >
    <Form ref="reportForm" :model="formData" :rules="reportRules">
      <div class="evaluation">
        <h3>Periodical Evaluation Sheet</h3>
        <div class="pd10 border-btm">
          Congratulations to {{name}} for having successfully completed the study of
          <Select v-model="formData.lessonNum" style="width:120px" prop="lessonNum">
            <Option :value="20">20</Option>
            <Option :value="40">40</Option>
            <Option :value="60">60</Option>
            <Option :value="80">80</Option>
          </Select> lessons
        </div>
        <div class="title">
          Part 1: Vocabulary and key language points:
        </div>
        <div class="mt10">
          (minimum 20 key words and 10 key sentences)
        </div>
        <FormItem prop="partOneVocabulary">
          <Input v-model="formData.partOneVocabulary" type="textarea" :rows="4" placeholder="Enter something..." prop="partOneVocabulary"/>
        </FormItem>
        <div class="title">
          Part 2: Ability for use
        </div>
        <div  class="title">
          1. Speaking
        </div>
        <div class="mt10">
          To see if the student speaks like native speakers.
        </div>
        <div class="mt10">
          1). Intonation
        </div>
        <div class="mt10">
          2). Speech fluency
        </div>
        <div class="mt10">
          3). Pronunciation accuracy
        </div>
        <div class="mt10">
          4). Speaking pace
        </div>
        <div class="mt10">
          Please write your comments from the above four aspects (at least 20 words):
        </div>
        <FormItem prop="partTwoSpeaking">
          <Input v-model="formData.partTwoSpeaking" type="textarea" :rows="4" placeholder="Enter something..." prop="partTwoSpeaking"/>
        </FormItem>
        <div class="title">
          2. Listening
        </div>
        <div class="mt10">
          To see if the student can understand and follow the teacher’s instructions or modelling.
        </div>
        <div class="mt10">
          Please write your comments according to the above criteria (at least 20 words):
        </div>
        <FormItem prop="partTwoListening">
          <Input v-model="formData.partTwoListening" type="textarea" :rows="4" placeholder="Enter something..." prop="partTwoListening"/>
        </FormItem>
        <div class="title">
          3. Usage of Sentences
        </div>
        <div class="mt10">
          To see if the student can use complete sentences, or better, compound sentences.
        </div>
        <div class="mt10">
          1). Comprehension of the sentences.
        </div>
        <div class="mt10">
          2). Output of complete sentences.
        </div>
        <div class="mt10">
          3). Clarity of expression
        </div>
        <div class="mt10">
          4). Grammatical accuracy
        </div>
        <div class="mt10">
          Please write your comments from the above four aspects (at least 20 words):
        </div>
        <FormItem prop="partTwoSentences">
          <Input v-model="formData.partTwoSentences" type="textarea" :rows="4" placeholder="Enter something..." prop="partTwoSentences"/>
        </FormItem>
        <div class="title">
          4. Adaptability
        </div>
        <div class="mt10">
          To see if the student can adapt to an English only class quickly and feels comfortable.
        </div>
        <div class="mt10">
          1). If the student actively speaks in classes.
        </div>
        <div class="mt10">
          2). If the interaction between the student and the tutor is natural and comfortable.
        </div>
        <div class="mt10">
          3). If the student can follow the classroom rules.
        </div>
        <div class="mt10">
          Please write your comments from the above three aspects (at least 20 words):
        </div>
        <FormItem prop="partTwoAdaptability">
          <Input v-model="formData.partTwoAdaptability" type="textarea" :rows="4" placeholder="Enter something..." prop="partTwoAdaptability"/>
        </FormItem>
        <div class="title">
          5. Interaction with the teacher
        </div>
        <div class="mt10">
          To see if the student can respond to the teacher, whether verbally or using body language.
        </div>
        <div class="mt10">
          Please write your comments according to the above criteria (at least 20 words):
        </div>
        <FormItem prop="partTwoInteraction">
          <Input v-model="formData.partTwoInteraction" type="textarea" :rows="4" placeholder="Enter something..." prop="partTwoInteraction"/>
        </FormItem>
        <div class="title">
          Part 3: Teacher’s comments (at least 25 words)
        </div>
        <div class="mt10">
          Comments that the tutor will give (it should include at least two parts: Suggestions about English learning , comments and suggestions about classroom behaviors)：
        </div>
        <FormItem prop="partThreeComments">
          <Input v-model="formData.partThreeComments" type="textarea" :rows="4" placeholder="Enter something..." prop="partThreeComments"/>
        </FormItem>
        <div class="title">
          Part 4: Tutor’s feedback about student’s English level
        </div>
        <div class="mt10">
          Tutor’s feedback about whether student English language ability suits for the current material level.
        </div>
        <FormItem prop="partFourFeedback">
          <Input v-model="formData.partFourFeedback" type="textarea" :rows="4" placeholder="Enter something..." prop="partFourFeedback"/>
        </FormItem>
      </div>
    </Form>
    <div slot="footer">
      <Button type="primary" size="large" @click="addStageReport">保存</Button>
    </div>
  </modal>
</template>
<script>
  export default {
    name: 'EvaluationSheetModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      },
      uid: {
        type: Number,
        default: null,
      },
      reprotId: {
        type: Number,
        default: null,
      },
      studentid: {
        type: Number,
        default: null,
      }
    },
    data () {
      return {
        reportRules: {
          lessonNum: [
            {required: true, message: 'error', trigger: 'blur'}
          ],
          partOneVocabulary: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partTwoSpeaking: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partTwoListening: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partTwoSentences: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partTwoAdaptability: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partTwoInteraction: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partThreeComments: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
          partFourFeedback: [
            {type: 'string', required: true, message: 'error', trigger: 'blur'}
          ],
        },
        name: '',
        formData: {
          id: '',
          lessonNum: '',
          uid: '',
          partOneVocabulary: '',
          partTwoSpeaking: '',
          partTwoListening: '',
          partTwoSentences: '',
          partTwoAdaptability: '',
          partTwoInteraction: '',
          partThreeComments: '',
          partFourFeedback: '',
          tutorId: '',
        },
        visible: false,
        submitShow: false,
      }
    },
    methods: {
      addStageReport () {
        let self = this
        self.$refs.reportForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('ERROR!')
            return
          }
          self.$http.post('/stageReport/updateReprot', self.formData).then(function (res) {
            if (res.data > 0) {
              self.$Message.success('保存成功')
              self.successCallback()
              self.visible = false
            }
          })
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          let self = this
          this.$emit('on-close')
          self.formData.lessonNum = ''
          self.formData.partOneVocabulary = ''
          self.formData.partTwoSpeaking = ''
          self.formData.partTwoListening = ''
          self.formData.partTwoSentences = ''
          self.formData.partTwoAdaptability = ''
          self.formData.partTwoInteraction = ''
          self.formData.partThreeComments = ''
          self.formData.partFourFeedback = ''
        }
      },
      uid (val) {
        this.formData.uid = val
        if (val) {
          let self = this
          self.$http.get('/userList/selectByUserId', {params: {uid: val}}).then(function (res) {
            if (res.data) {
              self.name = res.data.nickname
            }
          })
        }
      },
      reprotId (val) {
        if (val) {
          let self = this
          self.$http.get('/stageReport/selectByid?id=' + val).then(function (res) {
            if (res.data) {
              self.formData.id = res.data.id
              self.formData.uid = res.data.uid
              self.formData.lessonNum = res.data.lessonNum
              self.formData.partOneVocabulary = res.data.partOneVocabulary
              self.formData.partTwoSpeaking = res.data.partTwoSpeaking
              self.formData.partTwoListening = res.data.partTwoListening
              self.formData.partTwoSentences = res.data.partTwoSentences
              self.formData.partTwoAdaptability = res.data.partTwoAdaptability
              self.formData.partTwoInteraction = res.data.partTwoInteraction
              self.formData.partThreeComments = res.data.partThreeComments
              self.formData.partFourFeedback = res.data.partFourFeedback
            }
          })
        }
      },
      studentid (val) {
        if (val) {
          let self = this
          self.$http.get('/tch/selectAllId?uid=' + val).then(function (res) {
            if (res && res.data) {
              self.formData.tutorId = res.data.tutorId
            } else {
              self.formData.tutorId = ''
            }
          })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EvaluationSheetModal.vue?8a767770